module.exports = __webpack_public_path__ + "img/tg.20219192.png";